<div id="google-login">
  <div
    class="logo"
    style="text-align: center"
    [class.alldotgay-modal-logo-strip]="
      appContext?.siteName == 'alldotgay' && isModal
    "
  >
    <img
      src="{{ displaySetting?.header?.logo }} "
      alt="Logo Image"
      [ngClass]="{
        'sg-logowidth': appContext?.siteName == 'ShamalGroup',
        'joylife-logowidth': appContext?.siteName == 'Joy' ? true : appContext?.siteName == 'DemoPortal',
        'bookmecheapest-logowidth': appContext?.siteName == 'Gocaribbea',
        'ero-logowidth': appContext?.siteName == 'EroRentals',
        logowidth:
          appContext?.siteName !== 'ShamalGroup' &&
          appContext?.siteName !== 'Joy' &&
          appContext?.siteName !== 'DemoPortal' &&
          appContext?.siteName !== 'Gocaribbea' &&
          appContext?.siteName !== 'EroRentals'
      }"
    />
  </div>
  <div class="login-container" *ngIf="!isLoading">
    <div
      *ngIf="
        (loginpage && !isModal) ||
        (!mobileView && !isModal) ||
        (isModal && isModalLoginPage)
      "
      [ngClass]="{
        'sign-in-container': !isModal,
        'sign-in-container-modal': isModal
      }"
    >
      <div class="vertically-centered">
        <div style="width: 100%">
          <h2 class="title">Sign In</h2>
          <p class="sub-title">Welcome Back!</p>
          <div class="form" [formGroup]="loginForm" (ngSubmit)="onLogin()">
            <div class="form-container">
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput class="input" formControlName="email" />
              </mat-form-field>
              <span
                class="error"
                *ngIf="
                  loginSubmit &&
                  loginForm.controls['email'].hasError('required')
                "
                >Please enter your email address</span
              >
              <span
                class="error"
                *ngIf="
                  loginSubmit &&
                  !loginForm.controls['email'].hasError('required') &&
                  loginForm.controls['email'].hasError('email')
                "
                >Please enter your correct email address</span
              >
            </div>
            <div class="form-container">
              <mat-form-field>
                <mat-label>Enter your password</mat-label>
                <input
                  matInput
                  [type]="loginPassHide ? 'password' : 'text'"
                  class="input"
                  formControlName="password"
                />
                <button
                  mat-icon-button
                  matSuffix
                  (click)="loginPassHide = !loginPassHide"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="loginPassHide"
                >
                  <mat-icon>{{
                    loginPassHide ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
              </mat-form-field>
              <span
                class="error"
                *ngIf="
                  loginSubmit &&
                  loginForm.controls['password'].hasError('required')
                "
                >Please enter your password</span
              >
            </div>
            <a class="pass-reset-link" (click)="openResetPassDialog()"
              >Password playing hide and seek? Find it here!</a
            >

            <div class="form-button">
              <button type="submit" (click)="onLogin()">
                <span class="btn-font" [hidden]="loginLoader">LOGIN</span
                ><i [hidden]="!loginLoader" class="fa fa-spinner fa-spin"></i>
              </button>
            </div>
          </div>
          <div class="form-button webkitffx" *ngIf="googleLoginKey && !isModal">
            <div
              id="g_id_onload"
              [attr.data-client_id]="googleLoginKey"
              data-context="signin"
              data-ux_mode="popup"
              data-callback="handleSignInWithGoogle"
              data-auto_prompt="false"
            ></div>

            <div
              *ngIf="!mobileView"
              style="max-width: 28.75em"
              class="g_id_signin"
              data-type="standard"
              data-shape="rectangular"
              data-theme="outline"
              data-text="signin_with"
              data-size="large"
              data-width="400"
            ></div>

            <div
              *ngIf="mobileView"
              style="max-width: 28.75em"
              class="g_id_signin"
              data-type="standard"
              data-shape="rectangular"
              data-theme="outline"
              data-text="signin_with"
              data-size="large"
              data-width="262"
            ></div>
          </div>
          <a
            style="margin: 0.25rem"
            *ngIf="mobileView && !isModal"
            href="/signup"
            >Don't have an account, Sign-up!</a
          >
          <a
            class="auth-switch-link"
            style="margin: 0.25rem"
            *ngIf="isModal"
            (click)="isModalLoginPage = false"
            >Don't have an account, Sign-up!</a
          >
        </div>
      </div>
    </div>
    <div class="vertical-divider" *ngIf="!mobileView && !isModal"></div>
    <div
      *ngIf="
        (mobileView && signuppage && !isModal) ||
        (!mobileView && !isModal) ||
        (isModal && !isModalLoginPage)
      "
      [ngClass]="{
        'join-now-container': !isModal,
        'join-now-container-modal': isModal
      }"
    >
      <div class="vertically-centered">
        <div style="width: 100%">
          <div class="title-container">
            <h2 class="title">Create An Account</h2>
          </div>

          <div
            [ngClass]="{
              'sign-up-container': !isModal,
              'sign-up-container-modal': isModal
            }"
          >
            <div class="form" [formGroup]="signupForm" (ngSubmit)="onSignUp()">
              <div class="form-container">
                <mat-form-field>
                  <mat-label>Email</mat-label>
                  <input matInput class="input" formControlName="email" />
                </mat-form-field>
                <span
                  class="error"
                  *ngIf="
                    signupSubmit &&
                    signupForm.controls['email'].hasError('required')
                  "
                  >Please enter your email address</span
                >
                <!-- <span
                        class="error"
                        *ngIf="
                          signupForm.controls['email'].hasError('email')
                        "
                        >Please enter your correct email address</span
                      > -->
                <span
                  class="error"
                  *ngIf="
                    signupSubmit &&
                    signupForm.controls['email'].hasError('email')
                  "
                  >Please enter your correct email address</span
                >
              </div>
              <div class="form-container">
                <mat-form-field>
                  <mat-label>Create your password</mat-label>
                  <input
                    matInput
                    [type]="signupPassHide ? 'password' : 'text'"
                    class="input"
                    formControlName="password"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="signupPassHide = !signupPassHide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="signupPassHide"
                  >
                    <mat-icon>{{
                      signupPassHide ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                </mat-form-field>
                <span
                  class="error"
                  *ngIf="
                    signupSubmit &&
                    signupForm.controls['password'].hasError('required')
                  "
                  >Please enter your password</span
                >
                <span
                  class="error"
                  *ngIf="
                    signupSubmit &&
                    !signupForm.controls['password'].hasError('required') &&
                    signupForm.controls['password'].hasError('pattern')
                  "
                  >Password needs uppercase, lowercase, number, and special
                  character.</span
                >
                <span
                  class="error"
                  *ngIf="
                    signupSubmit &&
                    !signupForm.controls['password'].hasError('required') &&
                    !signupForm.controls['password'].hasError('pattern') &&
                    signupForm.controls['password'].hasError('minlength')
                  "
                  >Password should be atleast 8 character long</span
                >
              </div>

              <div class="form-container">
                <mat-form-field>
                  <mat-label>Confirm your password</mat-label>
                  <input
                    onkeypress=""
                    matInput
                    [type]="signupPassConfHide ? 'password' : 'text'"
                    class="input"
                    formControlName="confirmPassword"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="signupPassConfHide = !signupPassConfHide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="signupPassConfHide"
                  >
                    <mat-icon>{{
                      signupPassConfHide ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                </mat-form-field>
                <span
                  class="error"
                  *ngIf="
                    signupSubmit &&
                    signupForm.controls['confirmPassword'].hasError('required')
                  "
                  >Please enter your password</span
                >
                <span
                  class="error"
                  *ngIf="
                    signupSubmit &&
                    !signupForm.controls['confirmPassword'].hasError(
                      'required'
                    ) &&
                    signupForm.controls['confirmPassword'].hasError('pattern')
                  "
                  >Password needs uppercase, lowercase, number, and special
                  character.</span
                >
                <span
                  class="error"
                  *ngIf="
                    signupSubmit &&
                    !signupForm.controls['confirmPassword'].hasError(
                      'required'
                    ) &&
                    !signupForm.controls['confirmPassword'].hasError(
                      'pattern'
                    ) &&
                    signupForm.controls['confirmPassword'].hasError('minlength')
                  "
                  >Password should be atleast 8 character long</span
                >
              </div>
              <div class="form-button" style="margin-top: 1em">
                <button type="submit" (click)="onSignUp()">
                  <span class="btn-font" [hidden]="Showloader">SIGNUP</span
                  ><i [hidden]="!Showloader" class="fa fa-spinner fa-spin"></i>
                </button>
              </div>
            </div>
            <div class="form-button webkitffx mobile" *ngIf="mobileView">
              <div
                id="g_id_onload"
                data-client_id="193773163724-i6j07h6kkbcr6t7hf9fka77ht9r9nuc1.apps.googleusercontent.com"
                data-context="signin"
                data-ux_mode="popup"
                data-callback="handleSignInWithGoogle"
                data-auto_prompt="false"
              ></div>

              <div
                style="max-width: 18.75em"
                class="g_id_signin google-262"
                data-type="standard"
                data-shape="rectangular"
                data-theme="outline"
                data-text="signin_with"
                data-size="large"
                data-width="262"
              ></div>
            </div>
            <a
              class="auth-switch-link"
              style="margin: 0.25rem"
              *ngIf="isModal"
              (click)="isModalLoginPage = true"
              >Already have an account, Login!</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-button webkitffx" *ngIf="googleLoginKey && isModal">
    <div
      id="g_id_onload"
      [attr.data-client_id]="googleLoginKey"
      data-context="signin"
      data-ux_mode="popup"
      data-callback="handleSignInWithGoogle"
      data-auto_prompt="false"
    ></div>

    <div
      *ngIf="!mobileView"
      style="max-width: 28.75em"
      class="g_id_signin"
      data-type="standard"
      data-shape="rectangular"
      data-theme="outline"
      data-text="signin_with"
      data-size="large"
      data-width="400"
    ></div>

    <div
      *ngIf="mobileView"
      style="max-width: 28.75em"
      class="g_id_signin"
      data-type="standard"
      data-shape="rectangular"
      data-theme="outline"
      data-text="signin_with"
      data-size="large"
      data-width="262"
    ></div>
  </div>
</div>

<div *ngIf="isLoading" class="loader">
  <i class="fa fa-spinner fa-spin"></i>
</div>
